import Vue from 'vue/dist/vue.esm.browser';
import VueRouter from 'vue-router/dist/vue-router.esm.browser';

import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import Maps from 'highcharts/modules/map';

import axios from 'axios/dist/axios.min';
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min';
import 'moment/locale/ar.js';
import 'moment/locale/de.js';
import 'moment/locale/el.js';
import 'moment/locale/en.js';
import 'moment/locale/es.js';
import 'moment/locale/fr.js';
import 'moment/locale/he.js';
import 'moment/locale/it.js';
import 'moment/locale/ja.js';
import 'moment/locale/ko.js';
import 'moment/locale/pl.js';
import 'moment/locale/pt.js';
import 'moment/locale/ru.js';
import 'moment/locale/zh-cn.js';
import 'moment/locale/tr.js';
import 'moment/locale/uk.js';
import 'moment/locale/vi.js';
import 'moment/locale/ka.js';

import regeneratorRuntime from 'regenerator-runtime';

Vue.use(VueRouter);
Vue.use(HighchartsVue);

Maps(Highcharts);

Vue.config.productionTip = false;

window.Vue = Vue;
window.VueRouter = VueRouter;
window.Highcharts = Highcharts;
window.axios = axios;
window.moment = moment;
window.regeneratorRuntime = regeneratorRuntime;